/**
 * Поля формы «Правки внесены»: получатели, копия, срок «Завершить проверку правок до», комментарий.
 */
import { useRef } from 'react';
import { STAGE_DEADLINE } from '@stages/stages';
import { DateAutofillInput } from '@/components/ui/DateAutofillInput/DateAutofillInput';
import { UserRecipientCombo, type RecipientUserItem } from '@/components/UserRecipientCombo/UserRecipientCombo';
import { Textarea } from '@/components/ui/Textarea/Textarea';

export interface CorrectionsAppliedEmailFieldsProps {
  recipients: RecipientUserItem[];
  onRecipientsChange: (items: RecipientUserItem[]) => void;
  ccUsers: RecipientUserItem[];
  onCcUsersChange: (items: RecipientUserItem[]) => void;
  /** Срок этапа «Проверка правок», дд.мм.гггг */
  reviewDeadline: string;
  onReviewDeadlineChange: (value: string) => void;
  commentNote: string;
  onCommentNoteChange: (value: string) => void;
  disabled?: boolean;
}

export function CorrectionsAppliedEmailFields({
  recipients,
  onRecipientsChange,
  ccUsers,
  onCcUsersChange,
  reviewDeadline,
  onReviewDeadlineChange,
  commentNote,
  onCommentNoteChange,
  disabled,
}: CorrectionsAppliedEmailFieldsProps) {
  const recipientRef = useRef<HTMLDivElement>(null);
  const ccComboRef = useRef<HTMLDivElement>(null);

  return (
    <div className="review-check-email-modal__fields">
      <div className="review-check-email-modal__field">
        <UserRecipientCombo
          value={recipients}
          onChange={onRecipientsChange}
          placeholder="Получатель"
          containerRef={recipientRef}
          disabled={disabled}
        />
      </div>
      <div className="review-check-email-modal__field">
        <UserRecipientCombo
          value={ccUsers}
          onChange={onCcUsersChange}
          placeholder="Копия"
          containerRef={ccComboRef}
          disabled={disabled}
        />
      </div>
      <div className="review-check-email-modal__field">
        <DateAutofillInput
          value={reviewDeadline}
          onChange={onReviewDeadlineChange}
          placeholder={STAGE_DEADLINE['Проверка правок'].label}
          fullWidth
          disabled={disabled}
        />
      </div>
      <div className="review-check-email-modal__field">
        <Textarea
          value={commentNote}
          onChange={(e) => onCommentNoteChange(e.target.value)}
          placeholder="Комментарий к письму"
          fullWidth
          minRows={1}
          maxRows={40}
          inputClassName="review-check-email-modal__comment-input"
          disabled={disabled}
        />
      </div>
    </div>
  );
}
